import React, { useState } from "react";
import axios from "axios";
import { socket } from '../../utils';
import { useSelector } from 'react-redux';
import imageCompression from 'browser-image-compression';

import './FileUpload.scss';
const FileUpload = () => {
  const { engagement, user, ui, common } = useSelector(state=>state);
  const config = ui?.config?.attributes;
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploadedUrl, setUploadedUrl] = useState("");
  const [errorMessage, seterrorMessage] = useState("");

  const [uploadedFileName, setUploadedFileName] = useState("");
  let avayaPayload = '';
  let avayaImageName ='';

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];

    const fileType = selectedFile.type;
    console.log("fileTypeeeeee", fileType);
    console.log('originalFile instanceof Blob', selectedFile instanceof Blob); // true
    console.log(`originalFile size ${selectedFile.size / 1024 / 1024} MB`);
    if (selectedFile) {

      const fileType = selectedFile.type;
      if (!(fileType.includes('image/') || fileType === 'application/pdf')) {
        seterrorMessage("Please upload image or PDF files only");
        return;
      }
      const options = {
        maxSizeMB: 5,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      }

      try {
        let processedFile;
      
        if (fileType.includes('image/')) {
          // Compress the image
          const compressedFile = await imageCompression(selectedFile, options);
          console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
          console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`);
      
          // Convert Blob to File
          processedFile = new File([compressedFile], selectedFile.name, {
            type: compressedFile.type,
            lastModified: Date.now(),
          });
          setPreview(URL.createObjectURL(processedFile));
        } else if (fileType === 'application/pdf') {
          // No compression for PDFs, use as is
          processedFile = selectedFile;
          setPreview('');

        } else {
          seterrorMessage("Unsupported file type");
          return;
        }
      
        // Check file size (limit: 50MB)
        if (processedFile.size >= 20000000) {
          seterrorMessage(`Your file is ${processedFile.size / 1024 / 1024} MB. Please upload a smaller file.`);
          return;
        }
      
        seterrorMessage("");
        setFile(processedFile);
        console.log("selectedFile: ", selectedFile);
        console.log("processedFile: ", processedFile);
      
      } catch (error) {
        console.error(error);
        seterrorMessage("An error occurred while processing your file.");
      }      
    }
  };

  const _sendRichMessage = ()=>{
    // let elementText = {
    //     text: payload,
    //     textFormat:'PLAINTEXT'
    // } 

    // let body = {
    //     elementType: "text",
    //     elementText: elementText,
    //     payload: null,
    //     // richMediaPayload: {}
    // }

    // let normalizedPayload = payload.substring(1, payload.length-1);

    let richMedia = {
        "selectedAction": {
            "type": "reply",
            "payload": 'I_M_A_G_E_I_D_' + avayaPayload,
        }
    }

    let body = {
        "elementType": "reply",
        "elementText": {
            "text": avayaImageName,
            "textFormat": "PLAINTEXT"
        },
        "payload": 'I_M_A_G_E_I_D_' + avayaPayload,
        "richMediaPayload": richMedia
    }
    let message = {
        body: body,
        senderName: user.data.displayName,
        providerDialogId: engagement.params.CustomerVerified == "true" ? ((user.data.chProviderDialogId !== undefined) ? user.data.chProviderDialogId : user.data.providerDialogId) : user.data.providerDialogId,
        providerSenderId: engagement.params.CustomerVerified == "true" ? ((user.data.chProviderSenderId !== undefined) ? user.data.chProviderSenderId : user.data.providerSenderId) : user.data.providerSenderId,
        engagementParam: user.data.engagementParameters,
        customerIdentifiers: user.data.customerIdentifiers,
    }


    let s = socket.getInstance()
    s.emit("message",message,(res)=>{
        // setIsEmojiShown(false)
        if(res.hasError){
            console.log(res);
        //   engagementExists(engagement.data?.engagementId)
        }
    })
  }
  const handleUpload = async () => {
    if (!file) return alert("Please select a file first");
    const formData = new FormData();
    formData.append("image", file);
    formData.append('providerDialogId', '');
    formData.append('providerSenderId', '');
    formData.append('engagementParam',JSON.stringify(user.data.engagementParameters) );
    formData.append('customerIdentifiers',JSON.stringify( user.data.customerIdentifiers));
    try {
      const response = await axios.post(`${process.env.REACT_APP_CHATCON_URL}/image-upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setUploadedUrl(response.data.result.attachments[0].url);
      setUploadedFileName(response.data.result.attachments[0].name);
      seterrorMessage("");
      avayaPayload = response.data.result.attachments[0].attachmentId;
      avayaImageName = response.data.result.attachments[0].name;
      console.log(uploadedFileName);
      _sendRichMessage();
      console.log(response.data.result.attachments[0].name);
      // alert("File uploaded successfully");
    } catch (error) {
      console.error("Upload error:", error);
      seterrorMessage(error.message);
    }
  };
  return (
    <div className="upload-interface">
      {
        !uploadedUrl ? 
          <>
          <input type="file" accept="application/pdf, image/*" onChange={handleFileChange} />
          {preview && <img src={preview} alt="Preview" style={{ width: "200px", margin: "15px 0" }} />}
          <button className="dafabet"  style={{ marginTop: "20px" }} onClick={handleUpload}>Submit</button>
          </> : ""}
        {
          errorMessage ? 
          <>
          <h3 style={{ color: "red" }}>Upload failed due to following error:</h3>
          <p  style={{ fontWeight: "bold", color: "red" }}>{JSON.stringify(errorMessage)}</p>
          </> : ""
        }
      {uploadedUrl && (
        <div>
          <p  style={{ fontWeight: "bold", color: "green" }}>You have successfully uploaded file</p>
          {preview && <img src={uploadedUrl} alt="Uploaded" style={{ width: "200px", marginTop: "10px" }} />}
        </div>
      )}
    </div>
  );
};
export default FileUpload;
